import Home from "./pages/Home.jsx";
import Projects from "./pages/Projects.jsx";

const routes = [
    { path: "/", element: <Home /> },
    { path: "/projects", element: <Projects /> }
];

export default routes;